import moment from 'moment'

export default {
  name: 'v-date-time',
  props: [ 'value' ],
  data () {
    return {
      displayDate: '',
      dateModel: '',
      timeModel: '',
      monthNames: [
        'Jan', 'Feb', 'Mar',
        'Apr', 'May', 'June', 'Jul',
        'Aug', 'Sept', 'Oct',
        'Nov', 'Dec'
      ]
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (model) {
      }
    },
    currentSelection () {
      let selectedTime = this.timeModel
      return this.formatDate(this.dateModel) + ' ' + selectedTime
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return ''
      }
      const [year, month, day] = date.split('-')
      let monthName = this.monthNames[parseInt(month)]
      return `${monthName} ${day}, ${year}`
    },
    // Confirm the datetime selection and close the popover
    confirm () {
      this.onUpdateDate()
      this.close()
    },
    close () {
      this.$emit('close')
    },
    // Format the date and trigger the input event
    onUpdateDate () {
      if (!this.dateModel || !this.timeModel) {
        return false
      }
      let selectedTime = this.timeModel
      this.displayDate = this.formatDate(this.dateModel) + ' ' + selectedTime
      let dateTime = new Date(this.dateModel + ' ' + selectedTime)
      this.$emit('input', moment(dateTime).format('YYYY-MM-DD HH:mm')) // ('YYYY-MM-DD HH:mm'))
    }
  },
  mounted () {
    // Set the current date and time as default value
    let d = this.value
    if (typeof d === 'string') {
      d = new Date(d)
    }
    const currentHour = d.getHours() % 12 // AM,PM format
    const minutes = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
    const currentTime = currentHour + ':' + minutes
    this.timeModel = currentTime
    this.dateModel = d.toISOString().substr(0, 10)
  }
}
